import { useEffect, useRef } from "react";
import findAttendByEmail from "../../../utils/taskDetail/findAttendByEmail";

import styles from "./GuestModal.module.css";
import clsx from "clsx";
import { AttendeeType } from "../../../types/block/type";

interface GuestItemProps {
  data: AttendeeType[];
  email: string;
  onClick: (email: string) => void;
  isActive: boolean;
  isExistingGuest: boolean;
}

const GuestItem = ({ data, email, onClick, isActive, isExistingGuest }: GuestItemProps) => {
  const { name, imgUrl } = findAttendByEmail(data, email);
  const guestRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (!guestRef.current) return;

    isActive && guestRef.current?.scrollIntoView({ block: "center", behavior: "smooth" });
  }, [isActive, guestRef]);

  return (
    <li
      className={`${styles["guest-row"]} ${isActive && styles.guest_row_active}`}
      onMouseDown={(event) => event.preventDefault()}
      onClick={(event) => event.stopPropagation()}
      ref={guestRef}
    >
      <input
        type="radio"
        id={email}
        name="guestOption"
      />
      <label
        className={styles["guest-row__option"]}
        htmlFor={email}
        onClick={(e) => {
          e.stopPropagation();
          onClick(email);
        }}
      >
        <div className={clsx({ [styles["guest-row__icon-wrapper"]]: isExistingGuest })}>
          <div
            className={styles["guest-row__icon"]}
            style={{
              backgroundImage: `url(${imgUrl})`,
              backgroundSize: "cover",
            }}
          ></div>
          {isExistingGuest && <div className={styles["guest-row__icon-checkmark"]}></div>}
        </div>
        {name ? (
          <>
            <span
              className={clsx(styles["guest-row__name"], {
                [styles["guest-row__name--existing"]]: isExistingGuest,
              })}
            >
              {name}
            </span>
            <span
              className={clsx(styles["guest-row__email"], {
                [styles["guest-row__name--existing"]]: isExistingGuest,
              })}
            >{` (${email})`}</span>
          </>
        ) : (
          <span
            className={clsx(styles["guest-row__name"], {
              [styles["guest-row__name--existing"]]: isExistingGuest,
            })}
          >
            {email}
          </span>
        )}
      </label>
    </li>
  );
};

export default GuestItem;
